/** Shown only while the first auth callback is in flight. */
export default function Splash() {
  return (
    <div
      style={{
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--bg)',
      }}
    >
      <div className="stack" style={{ alignItems: 'center', gap: 14 }}>
        <div
          className="spin"
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            border: '2px solid var(--hairline)',
            borderTopColor: 'var(--accent)',
          }}
        />
        <span className="t-eyebrow">Loading</span>
      </div>
    </div>
  )
}
